module.exports = __webpack_public_path__ + "static/media/man_raoluo.0195dc05.png";